import React, {useState} from 'react';
import "./MoreLinks.css"
import AlertMessages from '../../../../../components/LoaderSuccessMessagesInPopup/LoaderSuccessMessagesInPopup';

const MoreLinks = (props) =>{
    const { imageSrc, cardTitle, cardDescription, link, response } = props;

    const [discountTileClicked, setDiscountTileClicked] = useState(false);

    return(
        <div className='more-card-container'
            onClick={() => { 
                    setDiscountTileClicked(true);
                } } >
             <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none'}} 
                >
                <div className='more-card-image'>
                    <img src={ imageSrc } alt="card" max-width="100%" height="auto" loading='lazy'/>
                </div>
                <div className='more-card-texts'>
                    <div className='more-card-title'>
                        {cardTitle}
                    </div>
                    <div className='more-card-description'>
                        {cardDescription}
                    </div>
                </div>
                 { discountTileClicked && response && <AlertMessages Response = { response } successMsg="Promocode ready redirecting to store" ></AlertMessages> }
            </a>
        </div>
    )
}

export default MoreLinks;